import { RangeDescriptor } from './RangeDescriptor';
import { FiltriOrdini } from '@/store';
import { ComparisonOperator } from '../enums/ComparisonOperator';
import { FinderBase } from './FinderBase';
import { FilterCampionarioProduzione } from '@/models';

export class FinderOrdini extends FinderBase
{
    public dataOrdine?: RangeDescriptor<Date>;

    public dataUltimaModifica?: RangeDescriptor<Date>;

    public numeroOrdine?: RangeDescriptor<string>;
    
    public includiCompletati: boolean = false;

    public soloUSA: boolean = false;
    public filterDatiAggiuntiviOrdiniForList: boolean = false;

    public campionarioProduzione: FilterCampionarioProduzione = FilterCampionarioProduzione.CampionarioEProduzione;

    public filtroModelli: string[] = [];

    public filtroStagioni: string[] = [];

    public filtroFasi: string[] = [];

    public filtroPartita: string = '';

    public constructor(idFornitore: string, pagina?: number) {
        super();
        
        this.idFornitore = idFornitore;
        if(pagina) {
            this.numeroPagina = pagina;
        }        
    }

    public ApplicaFiltriOrdini(filtri: FiltriOrdini) {
        this.includiCompletati = filtri.mostraCompletati;
        this.soloUSA = filtri.soloUSA;
        this.campionarioProduzione = filtri.campionarioEProduzione;
        
        this.filtroModelli = filtri.filtroModelli;
        this.filtroStagioni = filtri.filtroStagioni;
        this.filtroFasi = filtri.filtroFasi;
        this.filtroPartita = filtri.filtroPartita;

        if(filtri.numOrdine) {
            this.numeroOrdine = new RangeDescriptor(ComparisonOperator.Equal, filtri.numOrdine);
        }
    }
}
